<template lang="pug">
  .gvl-footer.pa-5
    v-row.align-end
      v-col.d-none.d-md-block(col="4")
      v-col.text-center.text-sm-left.text-md-center(cols="12" sm="6" md="4" lg="4")
        a.primary--text(target="blank" @click.prevent="openRoute('privacy')") Datenschutz &nbsp;|&nbsp;&nbsp;
        a.primary--text(target="blank" @click.prevent="openRoute('impressum')") Impressum

      v-col.text-center.text-sm-right(cols="12" sm="6" md="4" lg="4")
        a.d-inline-block(href="https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien" target="blank")
          img.logo--germany(src="@/assets/images/logo_germany.png")

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class PageFooter extends Vue {
  openRoute (name) {
    const { href } = this.$router.resolve({
      name: name
    })

    window.open(href, '_blank')
  }
}
</script>

<style lang="sass">
.gvl-footer
  font-size: 14px
  line-height: 16px
  z-index: 99

  a
    text-decoration: none

  .logo--germany
    height: 75px
</style>
